export const Buttons = {
  primary: {
    background: 'primary.main',
    '&:hover': {
      background: 'primary.main',
    },
    '&.Mui-disabled': {
      background: 'grey.300',
    },
  },
  primaryOutlined: {
    borderColor: 'primary.main',
    color: 'primary.main',
    '&:hover': {
      borderColor: 'primary.main',
    },
    '&.Mui-disabled': {
      borderColor: 'grey.300',
      color: 'grey.300',
    },
  },
};
